/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MaintenanceScheduleStateEnum } from './maintenanceScheduleStateEnum';


export interface MaintenanceScheduleDataSpec { 
    /**
     * Maintenance schedule end time
     */
    end_datetime?: Date;
    /**
     * If null or true, will notify recipients by email.
     */
    notify?: boolean;
    /**
     * List of Org Ids to be notified
     */
    org_ids?: Array<string>;
    /**
     * Maintenance schedule start time
     */
    start_datetime?: Date;
    state: MaintenanceScheduleStateEnum;
}
export namespace MaintenanceScheduleDataSpec {
}


